import { createApi } from "@reduxjs/toolkit/query/react";
import { rtkBaseQuery } from "../baseQuery";

export const userApi = createApi({
    baseQuery: rtkBaseQuery,
    reducerPath: "userApi",
    tagTypes: ["USER", "NEW_CHAT", "CHAT_HISTORY"],
    endpoints: (builder) => ({
        getRooms: builder.query({
            query: (data) => {
                return {
                    url: "/chatroom/list/",
                    method: "GET",
                };
            },
            providesTags: ["NEW_CHAT"]
        }),
        getChatHistory: builder.query({
            query: ({ roomId }) => {
                return {
                    url: `/chatroom/history/${roomId}/`,
                    method: "GET",
                };

            },
            providesTags: (result, error, { roomId }) => [{ type: 'CHAT_HISTORY', id: roomId }],
            transformResponse: (response) => {
                // Backend returns { chats, reference_document_name }; tolerate
                // the legacy bare-array shape during deploy skew.
                const chats = Array.isArray(response) ? response : (response?.chats || [])
                const referenceDocName = Array.isArray(response)
                    ? null
                    : (response?.reference_document_name || null)
                const roomArr = []
                if (chats?.length > 0) {
                    chats?.map((data) => {
                        roomArr.push({ sender: "user", text: data?.user_question, id: `user-${data?.id}` })
                        if (data?.bot_answer) {
                            roomArr.push({
                                sender: "bot",
                                text: data?.bot_answer,
                                id: data?.id,
                                citations: Array.isArray(data?.citations) ? data.citations : [],
                                hasTenantDocs: data?.answer_source === 'tenant_docs',
                                answerSource: data?.answer_source || 'ai_knowledge',
                                suggestions: Array.isArray(data?.suggestions) ? data.suggestions : [],
                            })
                        }
                        return data
                    })
                }

                return { messages: roomArr, referenceDocName }
            }
        }),
        createRoomChat: builder.mutation({
            query: ({ user_question, roomId, database_id }) => {

                return {
                    url: `/chatroom/send/${roomId}/`,
                    method: "POST",
                    body: { user_question, database_id },

                };

            },
            invalidatesTags: ["NEW_CHAT"]
        }),
        createNewRoomChat: builder.mutation({
            query: (data) => {

                return {
                    url: `/chatroom/send/`,
                    method: "POST",
                    body: data,

                };

            },
            invalidatesTags: ["NEW_CHAT"]
        }),
        fetchAnswerFromDB: builder.mutation({
            query: ({ query, database_id }) => {
                let apiUrl = "/chroma_db/";  
                if (database_id === "Database 2") {
                apiUrl = "/query/";  
                }
                else if (database_id === "Database 3") {
                    apiUrl = "/using-oracle/";
                }
                else{
                    apiUrl = "/chroma_db/";
                }

                return {
                    url: apiUrl,
                    method: "POST",
                    body: { query, database_id },
                };
            },
            invalidatesTags: ["NEW_CHAT"]
        }),
        updateChatFeedback: builder.mutation({
            query: ({ conversation_id, feedback }) => ({
                url: `/chat/${conversation_id}/feedback/`,
                method: 'POST',
                body: feedback,
            }),
    }),
    createEmptyRoom: builder.mutation({
        query: () => ({
            url: "/create_chat/",
            method: "POST",
            }),
    }),
    updateChatName: builder.mutation({
        query: ({ uuid_field, chat_room_name}) => ({
            url: `/chatroom/edit/${uuid_field}/`,
            method: "POST",
            body: {chat_room_name},
        }),
    }),
    deleteChatRoom: builder.mutation({
        query: (uuid_field) => ({
            url: `/chatroom/delete/${uuid_field}/`,
            method: "DELETE",
        }),
    })
    }),
});

export const {
    useGetRoomsQuery,
    useGetChatHistoryQuery,
    useCreateRoomChatMutation,
    useCreateNewRoomChatMutation,
    useFetchAnswerFromDBMutation,
    useUpdateChatFeedbackMutation,
    useCreateEmptyRoomMutation,
    useUpdateChatNameMutation,
    useDeleteChatRoomMutation,

} = userApi;


